import React from 'react';
export function MikronDNASection() {
  return <section className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-4250">
      <div className="bg-[#1874cd] py-6 px-6" data-id="element-4251">
        <h2 className="text-3xl font-bold text-white text-center" data-id="element-4252">
          Mikron DNA
        </h2>
      </div>
      <div className="overflow-x-auto" data-id="element-4253">
        <table className="w-full text-left border-collapse" data-id="element-4254">
          <thead data-id="element-4255">
            <tr className="bg-gray-50 border-b border-gray-200" data-id="element-4256">
              <th className="py-4 px-6 font-bold text-navy text-lg text-center w-1/3" data-id="element-4257">
                DNA
              </th>
              <th className="py-4 px-6 font-bold text-navy text-lg text-center w-1/3" data-id="element-4258">
                User Impact
              </th>
              <th className="py-4 px-6 font-bold text-navy text-lg text-center w-1/3" data-id="element-4259">
                What's the Big Deal?!
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 text-gray-700 text-center" data-id="element-4260">
            <tr className="hover:bg-gray-50 transition-colors" data-id="element-4261">
              <td className="py-4 px-6 font-bold text-navy" data-id="element-4262">
                Integrated Chuck
              </td>
              <td className="py-4 px-6" data-id="element-4263">
                Less Stack Error - Reach your tolerances faster
              </td>
              <td className="py-4 px-6" data-id="element-4264">Rarity in the market</td>
            </tr>
            <tr className="hover:bg-gray-50 transition-colors" data-id="element-4265">
              <td className="py-4 px-6 font-bold text-navy" data-id="element-4266">
                Direct Rotary Torque Table
              </td>
              <td className="py-4 px-6" data-id="element-4267">Dynamic, Precision, Less Wear</td>
              <td className="py-4 px-6" data-id="element-4268">
                Since 2001! Made in Mikron factory; not bought
              </td>
            </tr>
            <tr className="hover:bg-gray-50 transition-colors" data-id="element-4269">
              <td className="py-4 px-6 font-bold text-navy" data-id="element-4270">
                Step-Tec Spindle
              </td>
              <td className="py-4 px-6" data-id="element-4271">High RPM, 24/7 Run, Dependable</td>
              <td className="py-4 px-6" data-id="element-4272">
                1st 42k rpm spindle in 1992!
                <br data-id="element-4273" />
                Long life, extreme precision
              </td>
            </tr>
            <tr className="hover:bg-gray-50 transition-colors" data-id="element-4274">
              <td className="py-4 px-6 font-bold text-navy" data-id="element-4275">
                Pallet Changer System
              </td>
              <td className="py-4 px-6" data-id="element-4276">Unattended 2nd & 3rd Shift</td>
              <td className="py-4 px-6" data-id="element-4277">
                Industry leading affordability - Fast ROI
              </td>
            </tr>
            <tr className="hover:bg-gray-50 transition-colors" data-id="element-4278">
              <td className="py-4 px-6 font-bold text-navy" data-id="element-4279">Heidenhain CNC</td>
              <td className="py-4 px-6" data-id="element-4280">
                Best in Class for 5-axis, Contouring, Fully Loaded
              </td>
              <td className="py-4 px-6" data-id="element-4281">
                All models, no need for additional options,
                <br data-id="element-4282" />
                Utilizes Mikron Smart Modules
              </td>
            </tr>
            <tr className="hover:bg-gray-50 transition-colors" data-id="element-4283">
              <td className="py-4 px-6 font-bold text-navy" data-id="element-4284">
                Polymergranite Construction
              </td>
              <td className="py-4 px-6" data-id="element-4285">
                Thermalstability, Vibration Dampening, Heavy
              </td>
              <td className="py-4 px-6" data-id="element-4286">
                Handles high acceleration - Better surface finish,
                <br data-id="element-4287" />
                Better accuracy control
              </td>
            </tr>
            <tr className="hover:bg-gray-50 transition-colors" data-id="element-4288">
              <td className="py-4 px-6 font-bold text-navy" data-id="element-4289">
                High Acceleration
              </td>
              <td className="py-4 px-6" data-id="element-4290">
                Key to Fast Cycle Times & Long Tool Life
              </td>
              <td className="py-4 px-6" data-id="element-4291">$$$ Manage demands of customer</td>
            </tr>
            <tr className="hover:bg-gray-50 transition-colors" data-id="element-4292">
              <td className="py-4 px-6 font-bold text-navy" data-id="element-4293">
                Symmetrical Design
              </td>
              <td className="py-4 px-6" data-id="element-4294">Accuracy, Ergonomics</td>
              <td className="py-4 px-6" data-id="element-4295">Stability throughout the day</td>
            </tr>
            <tr className="hover:bg-gray-50 transition-colors" data-id="element-4296">
              <td className="py-4 px-6 font-bold text-navy" data-id="element-4297">
                Automation in Mind
              </td>
              <td className="py-4 px-6" data-id="element-4298">Designed - Not an after thought</td>
              <td className="py-4 px-6" data-id="element-4299">Ergonomic - No operator obstruction</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>;
}